import { jsx as _jsx } from "react/jsx-runtime";
import { Children, isValidElement } from "react";
import { Map as GeneratedMap, MapCompass, MapPitchToggle, MapUserLocationButton } from "./generated/Controls.native";
import { assertOneNativeChildren } from "./containerChildren";
var accepted = "One.iOS.MapCompass, One.iOS.MapPitchToggle, or One.iOS.MapUserLocationButton";
function Map(param) {
  var { children, ...props } = param;
  if (children !== void 0) {
    assertOneNativeChildren(children, "One.iOS.Map");
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = void 0;
    try {
      for (var _iterator = Children.toArray(children)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var child = _step.value;
        if (child === null || child === void 0 || typeof child === "boolean") continue;
        if (!/* @__PURE__ */ isValidElement(child) || child.type !== MapCompass && child.type !== MapPitchToggle && child.type !== MapUserLocationButton) throw new Error(`One.iOS.Map accepts ${accepted} elements as direct children`);
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator.return != null) {
          _iterator.return();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }
  }
  var NativeMap = GeneratedMap;
  return /* @__PURE__ */ _jsx(NativeMap, {
    ...props,
    children
  });
}
export {
  Map
};
//# sourceMappingURL=mapControls.native.js.map
